<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-head"><em>Contents</em></p>
<p class="toc-front" id="copy-1"><span href="#/CityBoy_copy" title="Link target outside of Sample">Copyright</span></p>
<p class="toc-front" id="pref-1"><a href="#/CityBoy_pref1"><em>Preface</em></a></p>
<p class="toc-chapter" id="chap-1"><a href="#/CityBoy_chap1">ONE: <em>The First Step in the Mending of a Broken Heart</em></a></p>
<p class="toc-chapter" id="chap-2"><a href="#/CityBoy_chap2">TWO: <em>Further Steps</em></a></p>
<p class="toc-chapter" id="chap-3"><a href="#/CityBoy_chap3">THREE: <em>The Visitor</em></a></p>
<p class="toc-chapter" id="chap-4"><a href="#/CityBoy_chap4">FOUR: <em>The “Place”</em></a></p>
<p class="toc-chapter" id="chap-5"><a href="#/CityBoy_chap5">FIVE: <em>The Safe</em></a></p>
<p class="toc-chapter" id="chap-6"><a href="#/CityBoy_chap6">SIX: <em>The Party</em></a></p>
<p class="toc-chapter" id="chap-7"><a href="#/CityBoy_chap7">SEVEN: <em>The Romance of Art and Natural History</em></a></p>
<p class="toc-chapter" id="chap-8"><a href="#/CityBoy_chap8">EIGHT: <em>The Dubbing of General Garbage</em></a></p>
<p class="toc-chapter" id="chap-9"><a href="#/CityBoy_chap9">NINE: <em>Promotion Day</em></a></p>
<p class="toc-chapter" id="chap-10"><a href="#/CityBoy_chap10">TEN: <em>A Man Among Men</em></a></p>
<p class="toc-chapter" id="chap-11"><a href="#/CityBoy_chap11">ELEVEN: <em>On to Manitou</em></a></p>
<p class="toc-chapter" id="chap-12"><a href="#/CityBoy_chap12">TWELVE: <em>Mr. Gauss's Camp Manitou</em></a></p>
<p class="toc-chapter" id="chap-13"><a href="#/CityBoy_chap13">THIRTEEN: <em>The Green Pastures</em></a></p>
<p class="toc-chapter" id="chap-14"><a href="#/CityBoy_chap14">FOURTEEN: <em>The Coming of Clever Sam</em></a></p>
<p class="toc-chapter" id="chap-15"><a href="#/CityBoy_chap15">FIFTEEN: <em>The Envelope Mystery</em></a></p>
<p class="toc-chapter" id="chap-16"><a href="#/CityBoy_chap16">SIXTEEN: <em>The Triumph of Lennie</em></a></p>
<p class="toc-chapter" id="chap-17"><a href="#/CityBoy_chap17">SEVENTEEN: <em>The Victory Speech of Mr. Gauss</em></a></p>
<p class="toc-chapter" id="chap-18"><a href="#/CityBoy_chap18">EIGHTEEN: <em>The Dance</em></a></p>
<p class="toc-chapter" id="chap-19"><a href="#/CityBoy_chap19">NINETEEN: <em>Herbie's Ride—I</em></a></p>
<p class="toc-chapter" id="chap-20"><a href="#/CityBoy_chap20">TWENTY: <em>Herbie's Ride—II</em></a></p>
<p class="toc-chapter" id="chap-21"><a href="#/CityBoy_chap21">TWENTY-ONE: <em>Herbie's Ride—III</em></a></p>
<p class="toc-chapter" id="chap-22"><a href="#/CityBoy_chap22">TWENTY-TWO: <em>The Triumph of Herbie</em></a></p>
<p class="toc-chapter" id="chap-23"><a href="#/CityBoy_chap23">TWENTY-THREE: <em>Disaster</em></a></p>
<p class="toc-chapter" id="chap-24"><a href="#/CityBoy_chap24">TWENTY-FOUR: <em>Lennie and Mr. Gauss Take Falls</em></a></p>
<p class="toc-chapter" id="chap-25"><a href="#/CityBoy_chap25">TWENTY-FIVE: <em>Going Home</em></a></p>
<p class="toc-chapter" id="chap-26"><a href="#/CityBoy_chap26">TWENTY-SIX: <em>The Truth Will Out</em></a></p>
<p class="toc-chapter" id="chap-27"><a href="#/CityBoy_chap27">TWENTY-SEVEN: <em>The Truth Often Hurts</em></a></p>
<p class="toc-chapter" id="chap-28"><a href="#/CityBoy_chap28">TWENTY-EIGHT: <em>The Reward</em></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// CityBoy_toc.vue?adf2133e